import { instance, errorService } from '@/services/api'
import { masterAPIs, screenType } from '@/services/authConstantsV1'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import { calculateGridHeight, showNotification, customComparator } from '@/services/calculate'
import Pagination from '@/components/DynamicComponents/Pagination'
import { gridProperties } from '@/services/column.config'
import { tableName } from '@/services/config'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
    Pagination,
  },
  props: {
    tabKey: String,
    type: String,
    role: String,
    screenId: Number,
    columnSettings: Array,
  },
  data: function () {
    const checkLength = (rule, value, callback) => {
      let reg = /^-?(?!$)\d{1,9}(?:\.\d{1,1})?$/
      if (rule.field === 'sequence_Number') {
        reg = /^\d*(d+)?$/
        if (!reg.test(value)) {
          callback(new Error('Please enter valid sequence number'))
        } else if (value < 1) {
          callback(
            new Error('Sequence number must be greater than or equals to 1'),
          )
        } else {
          callback()
        }
      } else if (rule.field === 'BSUOP_Description') {
        if (String(value).length > 100) {
          callback(
            new Error(
              'BSUOP description must be less than or equals to 100 characters',
            ),
          )
        } else {
          callback()
        }
      } else {
        if (!reg.test(value)) {
          callback(new Error('Please enter valid bsuop (e.g.: 123456789.1)'))
        } else {
          callback()
        }
      }
    }
    return {
      headStyle: {
        'font-weight': 'bold',
        background: 'transparent !important',
        color: '#000000d9 !important',
        padding: '0 10px',
      },
      count: 0,
      loading: true,
      spinner: false,
      defaultSortedBy: 'sequenceNumber',
      defaultSortOrder: true,
      page: 0,
      pageSize: 0,
      bsuopList: [],
      visible: false,
      modalTitle: '',
      form: {
        id: undefined,
        BSUOP: undefined,
        BSUOP_Description: undefined,
        sequence_Number: undefined,
        isActive: 1,
      },
      rules: {
        BSUOP_Description: [
          {
            required: true,
            message: 'Please enter BSUOP Description',
            trigger: 'blur',
          },
          { validator: checkLength, trigger: 'blur' },
        ],
        BSUOP: [
          { required: true, message: 'Please enter BSUOP', trigger: 'blur' },
          { validator: checkLength, trigger: 'blur' },
        ],
        sequence_Number: [
          {
            required: true,
            message: 'Please enter sequence number',
            trigger: 'blur',
          },
          { validator: checkLength, trigger: 'blur' },
        ],
      },
      selectedRowKeys: [],
      loadRefresh: false,
      frameworkComponents: null,
      tableParams: null,
      width: '100%',
      height: '400px',
      filters: {},
      tableState: null,
      gridOptions: {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        tooltipShowDelay: 0,
        rowSelection: 'multiple',
        defaultColDef: {
          sortable: true,
          suppressMovable: true,
          comparator: customComparator,
          resizable: true,
          menuTabs: ['filterMenuTab'],
          filterParams: {
            buttons: ['apply'],
            newRowsAction: 'keep',
          },
        },
      },
      columnDefs: gridProperties.master.columns.bsuop,
    }
  },
  beforeMount() {
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.pageSize = settings.application.defaultRecord
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'))
    this.loadingConfig()
  },
  mounted() {
    this.$root.$on('deleteBSUOP', this.deleteBSUOP)
    this.$root.$on('editBSUOP', this.getBSUOPById)
    window.addEventListener('resize', this.getWindowSize)
  },
  watch: {
    tabKey() {
      if (this.tabKey === '12') {
        this.filters = {}
        const data = this.gridOptions.api.getFilterModel()
        Object.keys(data).forEach(element => {
          const filterComponent = this.gridOptions.api.getFilterInstance(
            element,
          )
          filterComponent.setModel(null)
        })
        this.bsuopList = []
        this.loading = true
        this.getColumnSettings(this.gridOptions)
      }
    },
  },
  beforeDestroy() {
    this.$root.$off('editBSUOP')
    this.$root.$off('deleteBSUOP')
    window.removeEventListener('resize', this.getWindowSize)
  },
  methods: {
    loadingConfig() {
      this.frameworkComponents = gridProperties.master.frameworks
      this.gridOptions.isRowSelectable = node => {
        if (node.data) {
          if (node.data.isLinked || node.data.applicationId) return false
          else return true
        }
      }
      gridProperties.master.columns.bsuop.map(i => {
        if (i.field === 'action' || i.field === 'isActive' || !i.field) {
          i.hide = this.type === 'Template' || this.role !== 'Admin'
        }
      })
    },

    // Refresh BSUOP
    refreshBSUOP() {
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach(element => {
        const filterComponent = this.gridOptions.api.getFilterInstance(element)
        filterComponent.setModel(null)
      })
      this.loading = true
      this.loadRefresh = true
      this.bsuopList = []
      this.page = 0
      this.defaultSortedBy = 'sequenceNumber'
      this.defaultSortOrder = true
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'sequenceNumber',
            sort: 'asc',
          },
        ],
        defaultState: { sort: null },
      })
      this.selectedRowKeys = []
      this.gridOptions.api.destroyFilter()
      this.filters = {}
      this.getBSUOP(this.gridOptions)
    },

    // Close the dialog
    handleCancel() {
      this.visible = false
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Add New BSUOP
    addNew() {
      this.visible = true
      this.modalTitle = 'Add New BSUOP'
      this.form.BSUOP = undefined
      this.form.id = null
      this.form.BSUOP_Description = undefined
      this.form.sequence_Number = undefined
      this.form.isActive = 1
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Save BSUOP
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.spinner = true
          let url = masterAPIs.bsuop.add
          let method = 'post'
          let req = {
            bsuop: this.form.BSUOP,
            description: this.form.BSUOP_Description,
            sequenceNumber: this.form.sequence_Number,
            isActive: this.form.isActive,
          }
          if (this.form.id) {
            method = 'patch'
            url = masterAPIs.bsuop.details(this.form.id)
          } else {
            method = 'post'
            url = masterAPIs.bsuop.add
            req = {
              bsuop: this.form.BSUOP,
              description: this.form.BSUOP_Description,
              SequenceNumber: this.form.sequence_Number,
            }
          }
          instance[method](url, req)
            .then(response => {
              this.spinner = false
              this.visible = false
              showNotification(
                'success',
                this.form.id ? 'Update BSUOP' : 'Create BSUOP',
                this.form.id
                  ? 'BSUOP updated successfully!'
                  : 'BSUOP created successfully!',
              )
              if (this.form.id) {
                const newData = [...this.bsuopList]
                const index = newData.findIndex(i => i.id === this.form.id)
                newData[index] = _.get(response.data, 'result', null)
                this.bsuopList = newData
              } else {
                this.getBSUOP(this.tableParams)
              }
              this.$refs.ruleForm.resetFields()
            })
            .catch(error => {
              this.spinner = false
              errorService(error)
            })
        }
      })
    },

    // Load BSUOP
    getBSUOP(params, type) {
      const url = masterAPIs.bsuop.list
      const req = {
        pageSize: this.pageSize,
        currentPage: this.page,
        sortColumn: this.defaultSortedBy,
        isAscending: this.defaultSortOrder,
        bsuop: _.get(this.filters, 'bsuop', undefined),
        description: _.get(this.filters, 'description', undefined),
      }
      instance
        .post(url, req)
        .then(response => {
          this.tableParams = null
          this.tableParams = params
          this.bsuopList = _.get(response.data, 'result', [])
          this.count = _.get(response.data, 'totalCount', 0)
          this.height = calculateGridHeight(
            'bsuopTable',
            this.count > this.pageSize,
          )
          this.loading = false
          this.loadRefresh = false
          if (type === 'sort') {
            this.updateColumnSettings()
          }
        })
        .catch(error => {
          this.loading = false
          this.loadRefresh = false
          errorService(error)
        })
    },

    // Get BSUOP By Id
    getBSUOPById(id) {
      this.visible = true
      this.modalTitle = 'Edit'
      this.spinner = true
      const url = masterAPIs.bsuop.details(id)
      instance
        .get(url)
        .then(response => {
          this.form.id = _.get(response.data, 'result.id', null)
          this.form.BSUOP = _.get(response.data, 'result.bsuop', null)
          this.form.isActive = _.get(response.data, 'result.isActive', 0)
          if (this.type === 'Template') {
            this.form.BSUOP_Description = _.get(
              response.data,
              'result.bsuoP_Description',
              null,
            )
            this.form.sequence_Number = Number(
              _.get(response.data, 'result.sequence_Number', null),
            )
          } else {
            this.form.BSUOP_Description = _.get(
              response.data,
              'result.description',
              null,
            )
            this.form.sequence_Number = Number(
              _.get(response.data, 'result.sequenceNumber', null),
            )
          }
          this.spinner = false
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    confirmDelete(record) {
      this.loading = true
      const req = record ? [record.id] : this.selectedRowKeys
      instance
        .patch(masterAPIs.bsuop.delete, req)
        .then(response => {
          showNotification(
            'success',
            'Delete BSUOP',
            'BSUOP deleted successfully!',
          )
          this.refreshBSUOP()
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    // Delete All BSUOPs
    deleteAllType() {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete ${this.selectedRowKeys.length} selected BSUOPs ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to selected bsuop
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete()
        },
        onCancel() { },
        class: 'test',
      })
    },

    // Delete BSUOP
    deleteBSUOP(data) {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete '${this.type === 'Project'
          ? data.bsuopDescription
          : data.bsuoP_Description
        }' ?`,
        content: h => (
          <div style="color:red;">
            <p>This action will delete all information related to this bsuop</p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(data)
        },
        onCancel() { },
        class: 'test',
      })
    },

    // Ag Grid sort method
    sortChanged(value) {
      const colState = this.gridOptions.columnApi.getColumnState()
      const sortData = colState
        .filter(function (s) {
          return s.sort != null
        })
        .map(function (s) {
          return {
            colId: s.colId,
            sort: s.sort,
            sortIndex: s.sortIndex,
          }
        })
      this.loading = true
      this.bsuopList = []
      if (sortData.length > 0) {
        this.defaultSortedBy = sortData[0]['colId']
        this.defaultSortOrder = sortData[0]['sort'] === 'asc'
      } else {
        this.defaultSortedBy = 'sequenceNumber'
        this.defaultSortOrder = true
      }
      this.getBSUOP(this.gridOptions, 'sort')
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    getWindowSize() {
      this.height = calculateGridHeight(
        'bsuopTable',
        this.count > this.pageSize,
      )
    },

    onPagination(page) {
      this.loading = true
      this.page = page
      this.bsuopList = []
      this.selectedRowKeys = []
      this.getBSUOP(this.tableParams)
    },

    filterChanged() {
      this.filters = {}
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach((element, index) => {
        this.filters[element] = Object.values(data)[index]['filter']
      })
      this.loading = true
      this.page = 0
      this.bsuopList = []
      this.getBSUOP(this.gridOptions)
    },

    onColumnResized(e) {
      if (e.finished) {
        this.updateColumnSettings()
      }
    },

    updateColumnSettings() {
      if (this.role === 'Admin') {
        this.tableState = this.gridOptions.columnApi.getColumnState()
        const request = {
          type: !this.type ? screenType.bsuop : undefined,
          screenId: this.type ? this.screenId : undefined,
          tableName: this.type ? tableName.template.master.bsuop : undefined,
          columnDetails: JSON.stringify(this.tableState),
        }
        if (!this.type) {
          this.$emit('updateColumns', request)
        } else {
          this.$emit('updateColumnSettings', request)
        }
      }
    },

    getColumnSettings(params) {
      if (this.type) {
        const columnDetails = this.columnSettings.find(
          i =>
            i.screenId === this.screenId &&
            i.tableName === tableName.template.master.bsuop,
        )
        this.setColumnSettings(
          params,
          columnDetails ? columnDetails.columnDetails : null,
        )
        this.getBSUOP(this.gridOptions)
      } else {
        if (this.role === 'Admin') {
          instance
            .get(masterAPIs.columnSetting.get(screenType.bsuop))
            .then(response => {
              const tableState = _.get(
                response.data,
                'result.columnDetails',
                null,
              )
              this.setColumnSettings(params, tableState)
            })
            .catch(error => {
              this.spinner = false
              errorService(error)
            })
        } else {
          this.setColumnSettings(params)
        }
        this.getBSUOP(this.gridOptions)
      }
    },

    setColumnSettings(params, tableState) {
      if (tableState && this.role === 'Admin') {
        this.tableState = JSON.parse(tableState)
        if (this.tableState.find(i => i.sort)) {
          this.defaultSortedBy = this.tableState.find(i => i.sort).colId
          this.defaultSortOrder =
            this.tableState.find(i => i.sort).sort === 'asc'
        }
        this.tableState[0].hide = !!this.type
        this.gridOptions.columnApi.applyColumnState({
          state: this.tableState,
        })
      } else {
        this.defaultSortedBy = 'sequenceNumber'
        this.defaultSortOrder = true
        this.gridOptions.columnApi.applyColumnState({
          state: [
            {
              colId: 'sequenceNumber',
              sort: 'asc',
            },
          ],
          defaultState: { sort: null },
        })
        params.api.sizeColumnsToFit()
      }
    },
  },
}
